export enum SiteType {
    Publisher = 'publisher',
    Advertiser = 'advertiser'
}
